module.exports = __webpack_public_path__ + "static/ClickedTripWasCut-baa3352712d5716fb34fece0c3fcd24d.png";